import axios from 'axios';

export const startDigitalAuth = async (authRequest) => {
  const endpoint = authRequest.method === 'smartid' ? '/smartid/login' : '/mobileid/login';
  return await axios.post(endpoint, authRequest);
};

export const checkDigitalAuthStatus = (sessionId, method, phone = '') => {
  if (method === 'smartid') {
    return axios.get(`/smartid/status/${sessionId}`);
  } else {
    return axios.get(`/mobileid/status/${sessionId}?phone=${encodeURIComponent(phone)}`);
  }
};
